// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3fOo-","alert":"SettungsInbox_alert__1Dlcs"};